import baseApi from "@/api/baseApi";
export default {
  addOrUpdate(form) {
    return baseApi.post('/api-piglet/api/marketing-fee/v1', form)
  },
  fetchAll() {
    return baseApi.get(`/api-piglet/api/marketing-fee/v1`)
  },
  remove(id) {
    return baseApi.delete(`/api-piglet/api/marketing-fee/${id}/v1`)
  }
}
